import { Injectable } from '@angular/core';
import { MatLegacyDialogConfig, MatLegacyDialogRef } from '@angular/material/legacy-dialog';
import { GithubSyncDialogData } from '@mode/github/contract';
import { GithubSyncDialog } from '@mode/github/domain';
import { DialogService } from '@mode/shared/ui';
import { GithubSyncModalComponent } from './github-sync-modal/github-sync-modal.component';

@Injectable()
export class GithubSyncDialogService implements GithubSyncDialog {
  dialog: MatLegacyDialogRef<GithubSyncModalComponent, MatLegacyDialogConfig> | undefined;

  constructor(private dialogService: DialogService) {}

  open(data: GithubSyncDialogData) {
    this.dialog = this.dialogService.open({ component: GithubSyncModalComponent, matDialogConfig: { data } });
  }

  close() {
    this.dialog?.close();
  }
}
